import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
import { GoldButton } from './GoldButton';
export function HeroSection() {
  return <section className="relative w-full bg-navy-900 overflow-hidden" data-id="element-103">
      {/* Subtle radial glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-104">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-gold-500/5 rounded-full blur-[120px]" data-id="element-105" />
      </div>

      <div className="relative max-w-6xl mx-auto px-5 sm:px-8 pt-16 pb-20 md:pt-24 md:pb-28" data-id="element-106">
        <AnimatedSection className="text-center" data-id="element-107">
          {/* Eyebrow */}
          <AnimatedItem data-id="element-108">
            <span className="inline-block px-4 py-1.5 mb-6 text-xs font-body font-semibold tracking-[0.2em] uppercase text-gold-400 border border-gold-500/30 rounded-full" data-id="element-109">
              Sistema de Ingresos para tu Retiro
            </span>
          </AnimatedItem>

          {/* H1 */}
          <AnimatedItem data-id="element-110">
            <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white max-w-4xl mx-auto" data-id="element-111">
              PLAN RETIRO:{' '}
              <span className="text-gold-400" data-id="element-112">
                El Sistema de Ingresos Mensuales
              </span>{' '}
              para tu Jubilación Anticipada
            </h1>
          </AnimatedItem>

          {/* Subhead */}
          <AnimatedItem data-id="element-113">
            <p className="mt-6 md:mt-8 text-lg md:text-xl text-slate-300 max-w-3xl mx-auto font-body leading-relaxed" data-id="element-114">
              Deja de "ahorrar y rezar": Aprende a cobrar{' '}
              <span className="text-gold-300 font-semibold" data-id="element-115">
                rentas mensuales de la bolsa de valores
              </span>{' '}
              sin ser un experto financiero.
            </p>
          </AnimatedItem>

          {/* Product Mockup */}
          <AnimatedItem data-id="element-116">
            <motion.div className="mt-10 md:mt-14 flex justify-center" whileHover={{
            y: -4
          }} transition={{
            duration: 0.4
          }} data-id="element-117">
              <img src="https://cdn.magicpatterns.com/uploads/h47cBGRpt9ZRDhoC7w7mF9/heylloyd-image-1773431506947_Mockup_Plan_Retiro_3.png" alt="Plan Retiro - Guía digital mostrada en laptop" className="w-full max-w-xl md:max-w-2xl rounded-lg shadow-2xl shadow-black/40" data-id="element-118" />
            </motion.div>
          </AnimatedItem>

          {/* Opening Hook */}
          <AnimatedItem data-id="element-119">
            <div className="mt-10 md:mt-14 max-w-3xl mx-auto" data-id="element-120">
              <p className="text-base md:text-lg text-slate-300/90 font-body leading-relaxed" data-id="element-121">
                Si hoy dejaras de trabajar, ¿cuántos meses podrías mantener tu
                estilo de vida antes de que tus ahorros se agoten? La mayoría de
                las personas entre 25 y 50 años viven con la angustia silenciosa
                de saber que el Seguro Social no será suficiente y que sus
                ahorros en el banco están perdiendo valor cada día frente a la
                inflación.
              </p>
              <p className="mt-5 text-base md:text-lg text-white/90 font-body leading-relaxed font-medium" data-id="element-122">
                No tienes que esperar a los 65 años para tener tranquilidad.
                Existe una forma de obligar al mercado financiero a pagarte una{' '}
                <span className="text-gold-400" data-id="element-123">"renta" mensual</span>,
                depositada directamente en tu cuenta, sin importar si la
                economía sube o baja.
              </p>
            </div>
          </AnimatedItem>

          {/* Price + CTA */}
          <AnimatedItem data-id="element-124">
            <div className="mt-10 flex flex-col items-center gap-4" data-id="element-125">
              <span className="inline-block px-3 py-1 text-xs font-body font-bold tracking-wider uppercase bg-emerald-500/15 text-emerald-400 border border-emerald-500/25 rounded-full" data-id="element-126">
                78% de descuento
              </span>
              <div className="flex items-baseline gap-3" data-id="element-127">
                <span className="font-display text-2xl text-slate-500 line-through" data-id="element-128">
                  $29 USD
                </span>
                <span className="font-display text-4xl md:text-5xl font-bold text-gold-400" data-id="element-129">
                  $6.39
                </span>
                <span className="text-slate-400 font-body text-lg" data-id="element-130">USD</span>
              </div>
              <GoldButton data-id="element-131">Quiero Mi Plan Retiro Ahora</GoldButton>
            </div>
          </AnimatedItem>
        </AnimatedSection>
      </div>

      {/* Bottom divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" data-id="element-132" />
    </section>;
}